import { buildCountrySpecificConfig } from '../utils/countrySpecificConfig';

export const buildConfig = ({
  country,
  countrySelector,
  googleMapsApiKey,
  disableGoogleMapsApi = false,
  disableLiveValidation,
}) => {
  return {
    currentCountry: {
      name: country.name,
      code: country.code,
    },
    addressGeneralConfig: {
      copyright: 'labels.copyright',
      country: 'labels.country',
      changeAddress: 'labels.changeAddress',
      addAddress: 'labels.addAddress',
      billing: 'labels.billing',
      mailing: 'labels.mailing',
      shipping: 'labels.shipping',
      setDefault: 'labels.setDefault',
      countrySelectConfig: countrySelector,
      addressInputConfig: {
        ...buildCountrySpecificConfig(country.code.toUpperCase()),
        id: 'addressInput',
        name: 'addressInput',
        hint: 'labels.address.edit.hint',
        optional: 'labels.address.edit.optional',
        prompt: 'labels.address.edit.prompt',
        promptMobile: 'labels.address.edit.promptMobile',
        loading: 'labels.address.edit.loading',
        addressNotFoundText:
          'labels.address.edit.AddressNotFound.text',
        addressNotFoundButton:
          'labels.address.edit.AddressNotFound.button',
        lookupErrorLabel: 'labels.address.edit.lookupErrorLabel',
        label: 'labels.address.edit.label',
        searchCharLength: 4,
        googleMapsApiKey,
        disableGoogleMapsApi,
        disableLiveValidation,
      },
    },
  };
};
